import React from "react";
import App from "../App"; // Reutilizamos el componente actual como AppPage

const AppPage = () => {
  return <App />;
};

export default AppPage;
